import React from 'react'
import { useQuery } from 'react-query'

import {
  SummarySaleReportAcceptProps,
  SummarySaleReportProps,
} from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleReport/interface'
import { useWriterAction } from '@hooks/writer/useWriterAction'
import { useAuthentication } from '@hooks/useAuthentication'

const withSummarySaleReport = (Component: React.FC<SummarySaleReportProps>) => {
  function WithSummarySaleReport({
    dateSelected,
  }: SummarySaleReportAcceptProps) {
    const writerClient = useWriterAction()
    const { isWriter } = useAuthentication()
    const { data, isLoading } = useQuery(
      ['sale-summary', dateSelected],
      () => writerClient.querySaleSummary(dateSelected),
      {
        enabled: isWriter,
      }
    )
    const newProps = { data, isLoading, dateSelected }
    return <Component {...newProps} />
  }
  return WithSummarySaleReport
}

export default withSummarySaleReport
